import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linux-cloud',
  templateUrl: './linux-cloud.component.html',
  styleUrls: ['./linux-cloud.component.css']
})
export class LinuxCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
